/* Values are supplied by Liquid's native t filter for the active locale. */
(() => {
 'use strict';
 function create({translations={},translationKeys={}}){
  const t=(key,values={})=>(translations[key]??key).replace(/__liotro_([a-z_]+)__/g,(marker,name)=>Object.prototype.hasOwnProperty.call(values,name)?String(values[name]):marker);
  const text=value=>Object.prototype.hasOwnProperty.call(translationKeys,value)?t(translationKeys[value]):value;
  function editorial(value){if(typeof value==='string')return text(value);if(Array.isArray(value))return value.map(editorial);if(value&&typeof value==='object')return Object.fromEntries(Object.entries(value).map(([key,entry])=>[key,editorial(entry)]));return value;}
  return {t,text,editorial};
 }
 window.LiotroI18n={create};
 if(typeof document!=='undefined'){
  const node=document.querySelector('#liotro-language-data')||document.querySelector('#liotro-data');
  const active=create(node?JSON.parse(node.textContent):{});window.LiotroText=active.t;
  window.LiotroEscape=value=>String(value??'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
 }
})();
